import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SecretsPage } from '@/features/secrets';
// By its path, not the package (its index says why).
import { MembersOnly } from '@/features/workspaces/components/MembersOnly';

// Search values arrive JSON-parsed: `?description=2024` is a number, which a
// string-only schema would drop without a word.
const text = z
  .union([z.string(), z.number()])
  .transform(String)
  .optional()
  .catch(undefined);

export const Route = createFileRoute(
  '/workspaces/$workspaceId/integrations/secrets',
)({
  // `?create` opens the add form — the command palette's verb (spec 129);
  // `key`, `kind` and `description` fill it, and `?replace=KEY` opens that
  // entry's replace form instead: the MCP server's link to type a secret's
  // value outside the chat (spec 240).
  validateSearch: z.object({
    create: z.boolean().optional().catch(undefined),
    key: text,
    kind: z.enum(['secret', 'variable']).optional().catch(undefined),
    description: text,
    replace: text,
  }),
  component: SecretsRoute,
});

export function SecretsRoute() {
  const { workspaceId } = Route.useParams();
  const { create, key, kind, description, replace } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MembersOnly what="Secrets" workspaceId={workspaceId}>
      <SecretsPage
        workspaceId={workspaceId}
        createRequested={create === true}
        prefill={{ key, kind, description }}
        replaceRequested={replace}
        onRequestSpent={() => {
          void navigate({ search: {}, replace: true });
        }}
      />
    </MembersOnly>
  );
}
